<script setup lang="ts">
import type { TMenuItem } from '~/data/header';

const props = defineProps<{ item: TMenuItem }>();
const emit = defineEmits<{ (event: 'clickLink'): void }>();

const itemColumnsList = computed(() => {
    if (!props.item?.groups) return;
    return props.item.groups;
});


function handleOnClickLabel(toggleAccordion: ()=>void) {
    if (itemColumnsList.value) return toggleAccordion();

    navigateTo(props.item?.path);
    emit('clickLink');
};

function handleOnClickLink() {
    emit('clickLink');
};
</script>

<template>
    <Accordion>
        <template #head="{ isOpen, toggleAccordion }">
            <div 
                class="w-full px-2 py-4 flex items-center justify-between"
                :class="isOpen ? 'text-primary-500' : 'text-gray-500'"
                @click="handleOnClickLabel(toggleAccordion)"
            >
                <span class="text-body1-semibold">{{ props.item.label }}</span>
                <Icon 
                    v-if="itemColumnsList"
                    name="solar:alt-arrow-down-linear" 
                    size="24" 
                    class="transition-transform duration-300" 
                    :class="isOpen && '-rotate-180'"
                />
            </div>
        </template>
        <template v-if="itemColumnsList" #body>
            <div 
                v-for="group, index in itemColumnsList"
                :key="index"
                class="flex flex-col px-8"
            >
                <div v-for="cate in group" :key="cate.title">
                    <span class="block text-body2 text-gray-400 mb-3">{{ cate.title }}</span>
                    <div class="flex flex-col gap-1">
                        <NuxtLink
                            v-for="link in cate.items"
                            :key="link.title"
                            :to="link.path" 
                            :target="link?.targetBlank ? '_blank' : undefined"
                            class="flex items-center gap-2 p-3 cursor-pointer select-none rounded-lg 
                                transition-colors duration-300 hover:bg-primary-50 text-body2-semibold"
                            @click="handleOnClickLink"
                        >
                            {{ link.title }}
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </template>
    </Accordion>
</template>